import { beginTask, endTask } from 'redux-nprogress';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectDefaultFormula } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'gameStatsMatchups';
export const selectGameStatsMatchupsState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  matchups: [],
  year: null,
  startWeek: null,
  endWeek: null,
  position: '',
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

const gameStatsMatchupsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default gameStatsMatchupsReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_GAME_STATS_MATCHUPS_REQUEST = `${STORE_KEY}/LOAD_GAME_STATS_MATCHUPS_REQUEST`;
export const LOAD_GAME_STATS_MATCHUPS_SUCCESS = `${STORE_KEY}/LOAD_GAME_STATS_MATCHUPS_SUCCESS`;
export const LOAD_GAME_STATS_MATCHUPS_ERROR = `${STORE_KEY}/LOAD_GAME_STATS_MATCHUPS_ERROR`;
export const SET_GAME_STATS_MATCHUPS_POSITIONS = `${STORE_KEY}/SET_GAME_STATS_MATCHUPS_POSITIONS`;

export const setGameStatsMatchupsPosition = ({ position }) => ({
  type: SET_GAME_STATS_MATCHUPS_POSITIONS,
  payload: { position },
});

export const loadGameStatsMatchupsRequest = ({ year, startWeek, endWeek, formulaId, position }) =>
({
  type: LOAD_GAME_STATS_MATCHUPS_REQUEST,
  payload: { year, startWeek, endWeek, formulaId, position },
});
export const loadGameStatsMatchupsSuccess = (matchups) => ({
  type: LOAD_GAME_STATS_MATCHUPS_SUCCESS,
  payload: { matchups },
});
export const loadGameStatsMatchupsError = error => ({
  type: LOAD_GAME_STATS_MATCHUPS_ERROR,
  payload: { error },
});

actions[SET_GAME_STATS_MATCHUPS_POSITIONS] = (state, { payload: { position } }) => ({
  ...state, position,
});

actions[LOAD_GAME_STATS_MATCHUPS_REQUEST] = (
  state,
  { payload: { year, startWeek, endWeek, formulaId, position } },
) => ({ ...state,
  year,
  startWeek,
  endWeek,
  formulaId,
  position,
});
actions[LOAD_GAME_STATS_MATCHUPS_SUCCESS] = (state, { payload: { matchups } }) =>
({ ...state,
  matchups,
  hasLoaded: true,
});
actions[LOAD_GAME_STATS_MATCHUPS_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
});

export const loadGameStatsMatchups = (
  { year, startWeek, endWeek, formulaId, position },
) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadGameStatsMatchupsRequest({ year, startWeek, endWeek, formulaId, position }));
    const { team_stats_matchups } = await api.stats.getGameStatsMatchups(
      { year, startWeek, endWeek, formulaId },
    );

    dispatch(loadGameStatsMatchupsSuccess(team_stats_matchups));
  } catch (error) {
    console.error(error);
    dispatch(loadGameStatsMatchupsError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const GAME_STATS_MATCHUPS_VIEW = `${STORE_KEY}/GAME_MATCHUPS`;

viewNames[GAME_STATS_MATCHUPS_VIEW] = 'GameStatsMatchups';
routes[GAME_STATS_MATCHUPS_VIEW] = {
  path: '/stats/game-stat-matchups',
  thunk: async (dispatch, getState) => {
    const state = getState();
    const gameStatsMatchupsState = selectGameStatsMatchupsState(state);
    const {
      position: currentPosition,
      startWeek: currentStartWeek,
      endWeek: currentEndWeek,
    } = gameStatsMatchupsState;
    let { year, formulaId, startWeek, endWeek, position } = selectQuery(state);
    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectDefaultFormula(state).id;
    if (year === null || year === undefined || year === 'null') year = currentYear;
    // await dispatch(loadWeeks(year));

    if (typeof startWeek !== 'number' || startWeek < 1) {
      startWeek = currentStartWeek || 1;
    }

    // if endweek is undefined (no querystring), see if it's the current year and set endweek accordingly
    if (typeof endWeek !== 'number') {
      if (year === currentYear) {
        const weeks = await dispatch(loadWeeks(year));
        endWeek = typeof weeks !== 'undefined' ? weeks.payload.weeks.active_week || selectWeeks(getState(), year, 'projections')[0] : (year >= 2021 ? 18 : 17);
      } else {
        endWeek = currentEndWeek || selectWeeks(getState(), year, 'projections')[0];
        if (typeof endWeek !== 'number') {
          endWeek = 17;
        }
      }
    } else if (year === currentYear && endWeek > selectWeeks(getState(), year, 'projections')[0]) {
      endWeek = selectWeeks(getState(), year, 'projections')[0];
    }
    if (!position) position = currentPosition || 'colGroupsSetA';

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadGameStatsMatchups({ year, startWeek, endWeek, position, formulaId }));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/GameStatsMatchups/module/gameStatsMatchups.js